// extracted by mini-css-extract-plugin
export default {"BackToTop":"BackToTop-module__BackToTop--v8fAk","BackToTop--visible":"BackToTop-module__BackToTop--visible--HVWjC"};